const types = {
  WECHAT_OPEN_ID: 'wechat_open_id'
}

const state = {
  openId: ''
}

const mutations = {
  [types.WECHAT_OPEN_ID] (state, payload) {
    state.openId = payload.openId
  }
}

const actions = {
  setOpenId: ({commit}, payload) => {
    commit(types.WECHAT_OPEN_ID, payload)
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/user/user.js